// extracted by mini-css-extract-plugin
export default {"container":"CareRecipientListScopeByActivatedField_container__6UeV0"};